import gql from 'graphql-tag';

export default gql`
  mutation (
    $_id: MongoID!
    $name: String
    $description: String
    $photo: String
    $index: Float
    $status: EnumCourseStatus
  ) {
    updateCourse(
      _id: $_id
      record: { name: $name, description: $description, photo: $photo, index: $index, status: $status }
    ) {
      recordId
    }
  }
`;
